import {createContext} from "react"

export interface OfficeLocation {
    clinicID: number,
    olid: number,
    mEmployeeID: number,
    clinicName: string,
    address: string,
    city: string,
    state: string,
    zip: string,
    phone: string,
    latitude: string,
    longitude: string,
}

export interface IProvider {
    clinicID: number,
    clinicName: string,
    employeeID: number,
    mEmployeeID: number,
    employeeFirstName: string,
    employeeMidName: string,
    employeeLastName: string,
    clientId: string,
    expireTimeTicks: number,
    employeeRole: number,
    doctorPublicURL: string,
    officeLocations: Array<OfficeLocation>,
    clinicOnlineScheduleEnable: boolean,
}

export const defaultProviderInfo = {
    clinicID: 0,
    clinicName: "",
    employeeRole: 1,
    employeeID: 0,
    mEmployeeID: 0,
    employeeFirstName: "",
    employeeMidName: "",
    employeeLastName: "",
    clientId: "",
    expireTimeTicks: 0,
    officeLocations: [],
    doctorPublicURL: "",
    clinicOnlineScheduleEnable: false,
}

export const ProviderContext = createContext<IProvider>(defaultProviderInfo)
